import { createAsyncThunk as reduxCreateAsyncThunk } from "@reduxjs/toolkit";
import type { AppDispatch, RootState } from "../store";

// Define a reusable type for your ThunkConfig
type AppThunkConfig = {
  state: RootState;
  dispatch: AppDispatch;
};

// Create the pre-typed creator
export const createAsyncThunk = reduxCreateAsyncThunk.withTypes<AppThunkConfig>();
